import { gql } from "@apollo/client";

export const GET_CATEGORIES_FOR_SELECT = gql`
  query GET_CATEGORIES_FOR_SELECT {
    findManyCategory {
      id
      product_containers {
        id
      }
      category_profiles {
        id
        name
        language
      }
    }
  }
`;

export const DELETE_MANY_CATEGORIES = gql`
  mutation DELETE_CATEGORIES($ids: [Int!]!) {
    deleteManyCategory(where: { id: { in: $ids } }) {
      count
    }
  }
`;

export const GET_CATEGORIES = gql`
  query GET_CATEGORIES(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [CategoryOrderByWithRelationInput!]
  ) {
    findManyCategory(
      where: {
        category_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      category_profiles {
        id
        name
        language
      }
      product_containers {
        id
      }
      createdAt
      updatedAt
    }
    findManyCategoryCount(
      where: {
        category_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
    )
  }
`;

export const GET_CATEGORY = gql`
  query GetCategory($id: Int!) {
    findUniqueCategory(where: { id: $id }) {
      id
      image_icon {
        id
        src
      }
      image {
        id
        src
      }
      banners {
        id
        src
      }
      parent_categoryId
      schema_href
      show_in_menu
      menu_order
      content_blocks {
        id
      }
      category_profiles {
        id
        name
        description
        language
        meta_information {
          id
          permalink
          meta_title
          meta_description
        }
      }
      product_containers {
        id
      }
    }
  }
`;

export const CREATE_CATEGORY = gql`
  mutation CREATE_CATEGORY(
    $category_profiles: [CategoryProfileCustomInput!]!
    $image_icon: [String]
    $image: [String]
    $banners: [String]
    $parent_categoryId: Int
    $schema_href: String
    $selected_products: [ProductContainerWhereUniqueInput]!
    $show_in_menu: Boolean!
    $menu_order: Int
    $content_blocks: [ContentBlockWhereUniqueInput]
  ) {
    createNewCategory(
      category_profiles: $category_profiles
      image_icon: $image_icon
      image: $image
      banners: $banners
      parent_categoryId: $parent_categoryId
      schema_href: $schema_href
      selected_products: $selected_products
      show_in_menu: $show_in_menu
      menu_order: $menu_order
      content_blocks: $content_blocks
    ) {
      id
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UPDATE_CATEGORY(
    $where: CategoryWhereUniqueInput!
    $category_profiles: [CategoryProfileCustomInput!]!
    $image_icon: [String]
    $image: [String]
    $banners: [String]
    $parent_categoryId: Int
    $schema_href: String
    $selected_products: [ProductContainerWhereUniqueInput]!
    $show_in_menu: Boolean!
    $menu_order: Int
    $content_blocks: [ContentBlockWhereUniqueInput]
  ) {
    updateExistingCategory(
      where: $where
      category_profiles: $category_profiles
      image_icon: $image_icon
      image: $image
      banners: $banners
      parent_categoryId: $parent_categoryId
      schema_href: $schema_href
      selected_products: $selected_products
      show_in_menu: $show_in_menu
      menu_order: $menu_order
      content_blocks: $content_blocks
    ) {
      id
    }
  }
`;
